<template>
  <div>
    <b-tabs content-class=""
            class="Parte-border"
            lign="left"
            bottom
            active-nav-item-class="Parte--tab-active">
      <b-tab class="contentPartes"
             @click="formContent('parte')">
        <template v-slot:title>
          Parte
        </template>
        <div v-if="(['CASAMENTO', 'HABILITACAO', 'OBITO'].indexOf(propTipo) === -1) && (parte.pessoa.pessoa_id || showDeclaranteInput)">
          <div class="form-group mt-2">
            <span class="custom-control custom-switch custom-control-inline mr-4">
              <input :id="`declarante-${ dinamicId }`"
                     v-model="tipo"
                     v-validate="{required: true}"
                     :class="{ 'is-invalid': errors.has('tiposPartes') }"
                     class="custom-control-input"
                     name="tiposPartes"
                     type="checkbox"
                     @change="validateInputs(`declarante-${ dinamicId }`)"
                     @keydown.enter="changeTipo(type.value)">
              <label class="custom-control-label"
                     :for="`declarante-${ dinamicId }`">Declarante</label>
            </span>
          </div>
        </div>
        <div v-if="['CASAMENTO', 'HABILITACAO'].indexOf(propTipo) != -1">
          <div class="form-group mt-2">
            <div v-for="(type, ind) in switches.filter(type => type.registro.find(registro => registro == 'CASAMENTO' ))"
                 :key="ind"
                 class="custom-control custom-switch custom-control-inline">
              <input :id="`${ type.idText }_${ _uid }`"
                     v-validate="{required: true}"
                     :checked="(type.value === parte.tipo)"
                     class="custom-control-input"
                     :class="[{ 'is-invalid': errors.has('tiposPartes') }, `input-${ type.idText }`]"
                     name="tiposPartes"
                     type="checkbox"
                     :value="type.value"
                     @change="changeTipo(type.value)"
                     @keydown.enter="changeTipo(type.value)">
              <label class="custom-control-label"
                     :for="`${ type.idText }_${ _uid }`">{{ type.text }}</label>
            </div>
          </div>
        </div>
        <div v-if="(propTipo === 'OBITO')">
          <div class="form-group mt-2">
            <div v-for="(type, ind) in switches.filter(type => type.registro.find(registro => registro == 'OBITO' ))"
                 :key="ind"
                 class="custom-control custom-switch custom-control-inline">
              <input :id="`${ type.idText }_${ _uid }`"
                     v-validate="{required: true}"
                     :class="[{ 'is-invalid': errors.has('tiposPartes') }, `input-${ type.idText }`]"
                     :checked="(type.value === parte.tipo)"
                     class="custom-control-input"
                     name="tiposPartes"
                     type="checkbox"
                     :value="type.value"
                     @change="changeTipo(type.value)"
                     @keydown.enter="changeTipo(type.value)">
              <label class="custom-control-label"
                     :for="`${ type.idText }_${ _uid }`">{{ type.text }}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label class="label"
                     for="cpfParte">CPF
                {{ ['DECLARANTE', 'PROCURADOR'].indexOf(switches.find(sw => sw.value === parte.tipo).value) >= 0 ? 'do' : 'da' }}
                {{ switches.find(sw => sw.value === parte.tipo).text.toLowerCase() }}
              </label>
              <input id="cpfParte"
                     ref="cpf_parte"
                     v-model="parte.pessoa.cpf"
                     v-mask="`999.999.999-99`"
                     v-validate="{ regex: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/ }"
                     :class="{ 'is-invalid': errors.has('cpfParte') }"
                     class="form-control form-control-sm"
                     name="cpfParte"
                     placeholder="000.000.000-00"
                     type="text"
                     @change="searchCPF()">
              <small v-if="errors.has('cpfParte')"
                     class="invalid-feedback">{{ errors.first('cpfParte') }}</small>
            </div>
          </div>

          <div class="col-sm-5 col-md-8">
            <div class="form-group">
              <label class="label"
                     for="nomeParte">Nome <span class="text-danger"> * </span></label>
              <input id="nomeParte"
                     v-model.lazy="parte.pessoa.nome"
                     v-uppercase
                     v-validate="{ required: true }"
                     :class="{ 'is-invalid': errors.has('nomeParte') }"
                     class="form-control form-control-sm text-uppercase"
                     name="nomeParte"
                     placeholder="Astrogilda Manuelita Spitz"
                     type="text"
                     @change="validateInputs('nomeParte')">
              <small v-if="errors.has('nomeParte')"
                     class="invalid-feedback">{{ errors.first('nomeParte') }}</small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label class="label"
                     :for="`profissaoParte${parte.pessoa.nome}`">Profissão</label>
              <input :id="`profissaoParte${parte.pessoa.nome}`"
                     v-model="parte.pessoa.ocupacao_declarada"
                     class="form-control form-control-sm"
                     name="ocupacao_declarada"
                     placeholder="Padeiro"
                     type="text"
                     @change="changed">
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="label"
                     for="nacionalidadeParte">Nacionalidade</label>
              <Nacionalidades id="nacionalidadeParte"
                              v-model="parte.pessoa.nacionalidade_codigo"
                              :prop-nacionalidade="parte.pessoa.nacionalidade"
                              @updated="changeNacionalidade" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label class="label"
                     for="estadoCivilParte">Estado Civil</label>
              <v-select v-model="parte.pessoa.estado_civil"
                        class="form-control form-control-sm"
                        :options="ESTADOS_CIVIL.map(est => est.name)"
                        placeholder="Selecione"
                        @input="changed" />
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab class="contentDocumentos"
             @click="formContent('documentos')">
        <template v-slot:title>
          Documentos
        </template>
        <Documentos class="mt-2"
                    :documentos="parte.pessoa.documentos"
                    :prop-hide-swal="true"
                    @DocumentoAdded="addDocumento"
                    @DocumentoRemoved="removeDocumento" />
      </b-tab>
      <b-tab class="contentEndereco"
             @click="formContent('endereco')">
        <template v-slot:title>
          Endereço
        </template>
        <BoxEndereco :prop-mostrar-exterior="true"
                     :prop-cartorio="propCartorio"
                     :data="parte.pessoa.endereco || {}"
                     :no-header="true"
                     @onEnderecoAdd="getAddress" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  /* components */
  import Documentos from '@/components/SofiaRei/Obito/Passos/Sessoes/Documentos'
  import BoxEndereco from '@/components/SofiaRei/BoxEndereco'

  /* services */
  import PessoasService from "@/services/Pessoas"

  /* filters */
  import { filterMaskedNumber } from '@/filters/filters'

  /* constants */
  import { ESTADOS_CIVIL } from "@/constants/estadosCivil"
  import Nacionalidades from "@/components/SofiaRei/Nacionalidades"

  /* libraries */
  import moment from 'moment'

  export default {
    name: 'FormPartes',
    components: { Documentos, Nacionalidades, BoxEndereco },
    inject: ['$validator'],
    props: {
      data: { type: Object },
      propParte: { type: Object, default: () => {} },
      showDeclaranteInput: Boolean,
      readOnly: { type: Boolean, default: () => false },
      propTipo: { type: String, default: () => ''},
      propCartorio: { type: Object, default: () => { return {} } },
      propValidateDeclarante: { type: Boolean, default: () => false },
      propValidateTipos: { type: Boolean, default: () => false }
    },
    data () {
      return {
        id: null,
        parte: {
          pessoa: {
            nome: '',
            endereco: {},
            documentos: [],
            nacionalidade_codigo: 76,
            nacionalidade: {
              nacionalidade_codigo: 76,
              nome: 'Brasil',
              nome_masculino: 'brasileiro',
              nome_feminino: 'brasileira'
            }
          },
          ... this.propParte
        },
        tipo: this.propParte && this.propParte.tipo === "DECLARANTE" ? true : false,
        selecNacionalidadesIsLoading: false,
        ESTADOS_CIVIL,
        dinamicId: Math.random(),
        switches: [
          {
            idText: 'parteDeclarante',
            text: 'Declarante',
            value: 'DECLARANTE',
            registro: ['OBITO']
          },{
            idText: 'parteTestemunha',
            text: 'Testemunha',
            value: 'TESTEMUNHA',
            registro: ['OBITO', 'CASAMENTO']
          },{
            idText: 'parteARogo',
            text: 'Testemunha a rogo',
            value: 'TESTEMUNHA_A_ROGO',
            registro: ['OBITO', 'CASAMENTO']

          },{
            idText: 'parteProcurador',
            text: 'Procurador',
            value: 'PROCURADOR',
            registro: ['CASAMENTO']
          }
        ]
      }
    },
    watch: {
      propParte () {
        this.tipo = this.propParte && this.propParte.tipo === "DECLARANTE" ? true : false,
        this.init()
      },
    },
    beforeMount () {
      this.id = this._uid
    },
    mounted () {
      this.controlEvent().addEvent()
      this.init()

      setTimeout(() => {
        this.$refs.cpf_parte.focus()
      }, 100)
    },
    methods: {
      init () {
        this.parte = {...this.propParte}
        this.parte.pessoa = {...this.propParte.pessoa}
        this.$validator.reset()
      },

      async validaCpfInformado () {
        if (!this.parte.pessoa.cpf) return false

        // Verifica se o cpf é o mesmo do registrado
        if (this.data && (this.data.cpf === this.parte.pessoa.cpf)) {
          objSwal.error.text = 'Não é possível cadastrar um parte com o mesmo CPF do falecido'
          return true
        }

        // Busca falecido
        let dataRegistro = moment().format('YYYY-MM-DD')

        if (this.data && this.data.registro && this.data.registro.data_registro) {
          dataRegistro = this.data.registro.data_registro
        }

        const buscaCpf = await PessoasService.getCpfFalecido(this.parte.pessoa.cpf, dataRegistro)

        if (buscaCpf.existFalecido) {
          objSwal.error.text = 'Não é possível cadastrar uma parte falecido(a) antes da data desse registro'
        }

        return buscaCpf.existFalecido
      },

      async searchCPF () {
        let cpf = filterMaskedNumber(this.parte.pessoa.cpf)

        if (cpf) {
          cpf = cpf.replace(/_/g, "")

          if (cpf.length !== 11) return

          if (cpf.length > 10) {
            const dados = await PessoasService.getPessoaByCPF(cpf)

            if (!dados.isEmpty) {
              const { nome } = dados

              if (nome) this.parte.pessoa.nome = nome
            }
          }
        }

        const existCPF = await this.validaCpfInformado()

        if (existCPF) {
          delete this.parte.pessoa.cpf

          this.parte.pessoa = { ...this.parte.pessoa }

          objSwal.error = {
            ...objSwal.error,
            title: '',
            html: ''
          }

          return Swal.fire(objSwal.error)
        }

        this.parte.pessoa.cpf = this.parte.pessoa.cpf || null

        this.changed()
      },

      addDocumento (documento) {
        if (!this.parte.pessoa.documentos) {
          this.parte.pessoa.documentos = []
        }
        
        this.parte.pessoa.documentos.push(documento)
        this.changed()
      },

      removeDocumento (documento) {
        this.$emit('DocumentoRemoved', documento)
        this.parte.pessoa.documentos = this.parte.pessoa.documentos.filter((doc) => doc.numero != documento.numero )
        this.changed()
      },

      getAddress (endereco) {
        this.parte.pessoa.endereco = endereco
        this.changed()
      },

      changeNacionalidade (nacionalidade) {
        this.parte.pessoa.nacionalidade = nacionalidade
        this.changed()
      },

      changed () {
        this.$emit('changed', this.parte)
      },
      upperName () {
        if (this.parte.pessoa.nome) {
          this.parte.pessoa.nome = this.parte.pessoa.nome.toUpperCase()
        }
      },

      limitText (count) { return `e ${count} outros` },

      changeTipo (tipo) {
        this.parte.tipo = tipo
        this.changed()
      },
      deleteAddress (endereco) {
        this.$emit('removeEndereco', endereco)
        this.changed()
      },
      validateInputs (name) {
        this.upperName()
        this.$validator.validate(name)
        this.changed()
      },
      formContent (content) {
        const tabPartes = document.querySelector('.contentPartes')
        const tabDocumentos = document.querySelector('.contentDocumentos')
        const tabEndereco = document.querySelector('.contentEndereco')

        setTimeout(() => {
          switch (content) {
          case 'parte':
            tabPartes.focus()

          case 'documentos':
            tabDocumentos.focus()

          case 'endereco':
            tabEndereco.focus()
          }
        }, 200)
      },
      controlEvent () {
        const addEvent = () => {
          setTimeout(() => {
            const abas = document.querySelectorAll('.nav-link')
            const btnSubmit = document.querySelector('#btn-submit-parte')
            const btnCancel = document.querySelector('#btn-cancel-parte')

            if (abas.length) {
              abas.forEach(aba => {
                aba.onkeydown = nextAba
              })
            }

            if (btnSubmit) {
              btnSubmit.onkeydown = firstAba
            }

            if (btnCancel) {
              btnCancel.onkeydown = firstAba
            }
          }, 400)
        }

        const nextAba = (event) => {
          if (event.key != 'Tab' && event.key != 'Enter') return

          const abas = document.querySelectorAll('.nav-link')

          const partes = document.querySelector('.contentPartes')
          const documentos = document.querySelector('.contentDocumentos')
          const endereco = document.querySelector('.contentEndereco')

          const abasArr = Array.from(abas)

          const index = abasArr.findIndex(aba => aba.id == event.target.id)

          if (index != -1 && index != abasArr.length - 1 && event.key == 'Tab') {
            setTimeout(() => {
              abas[index + 1].focus()
            }, 100)
          }

          if (event.key == 'Enter') {
            setTimeout(() => {
              const abaSelected = document.querySelector('.nav-link.active.Parte--tab-active')
              const indexSelected = abasArr.findIndex(aba => aba == abaSelected)

              switch (indexSelected) {
              case 0:
                partes.focus()

              case 1:
                documentos.focus()

              case 2:
                endereco.focus()
              }
            }, 200)
          }

        }

        const firstAba = (event) => {
          if (event.key != 'Tab') return

          const formPartes = document.querySelector('.Parte-border')
          const abas = formPartes.querySelectorAll('.nav-link')
          const btnSubmit = document.querySelector('#btn-submit-parte')

          if (abas) {
            if (event.target.id == 'btn-cancel-parte' && (btnSubmit && btnSubmit.disabled) || event.target.id == 'btn-submit-parte') {
              setTimeout(() => {
                const formPartes = document.querySelector('.Parte-border')
                const abas = formPartes.querySelectorAll('.nav-link')
                const abasArr = Array.from(abas)

                const tabDocumentos = document.querySelector('.contentDocumentos')

                // Selecionando os primeiros campos de cada aba
                const firstInputparte =  this.propTipo == 'OBITO' ? document.querySelector('.input-parteDeclarante') : document.querySelector('.input-parteTestemunha')
                const firstInputDocumento = tabDocumentos.querySelector('.selectDocumentos')
                const firstInputEndereco = document.querySelector('.foraBrasil')
                
                // Obtendo a posição do index para focar no primeiro input do formulário que estiver aberto
                const abaSelected = document.querySelector('.nav-link.active.Parte--tab-active')
                const indexSelected = abasArr.findIndex(aba => aba == abaSelected)

                switch (indexSelected) {
                case 0:
                  firstInputparte.focus()

                case 1:
                  firstInputDocumento.focus()

                case 2:
                  firstInputEndereco.focus()
                }        
              }, 100)
            }
          }
        }

        return { addEvent, nextAba, firstAba }
      }
    }
  }
</script>

<style lang="scss">
  @import '@/scss/_utilities/_exports';

  .Parte {
    & .nav-link {
      border: 1px solid $sinoreg-blue !important;
      color: $color-black;
      font-size: pxToRem(15);
      border-top-left-radius:0;
      border-top-right-radius:0;
    }

    &--tab-active {
      background-color: $sinoreg-blue !important;
      border: 1px solid $sinoreg-blue !important;
      color: white !important;
      fill: white !important;
      font-weight: bold;
    }

    &-border ul.nav {
      border-bottom: 3px solid $sinoreg-blue !important;
    }

    &-border ul.nav > li.nav-item > a {
      border: 1px solid #696969;
      border-bottom: 0;
      border-top-left-radius:5px;
      border-top-right-radius:5px;
      color: black;
      font-size: pxToRem(15);
    }

    &-border ul.nav > li.nav-item > a:hover {
      border: 1px solid #696969;
      border-bottom: 0;
      border-top-left-radius:5px;
      border-top-right-radius:5px;
    }
  }
</style>
